document.addEventListener("DOMContentLoaded", () => {
  // Selecciona todos los enlaces dentro del menú "Descargar Material"
  const links = document.querySelectorAll('.hdt-sub-menu a');

  links.forEach(link => {
    const href = link.getAttribute('href');

    // Verifica si el enlace corresponde a un PDF, Google Drive o dominio de catálogos
    if (
      href &&
      (
        href.includes('.pdf') ||
        href.includes('drive.google.com') ||
        href.includes('catalogo.babalu.com.co')
      )
    ) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });
});